import {
  CardElement,
  useElements,
  useStripe,
  Elements,
} from "@stripe/react-stripe-js";
import { PaymentIntent, StripeElements } from "@stripe/stripe-js";
import { NextPage } from "next";
import { VFC, useState, useEffect } from "react";
import { Entry } from "../components/Entry";
import { Layout } from "../components/Layout";
import * as config from "../config";
import { fetchPostJSON } from "../utils/api-helpers";
import getStripe from "../utils/get-stripejs";

const EntryPage: NextPage = () => {
  const [paymentIntent, setPaymentIntent] = useState<PaymentIntent | null>(
    null
  );

  useEffect(() => {
    fetchPostJSON("/api/payment_intents", {
      amount: 1000,
    }).then((data) => {
      setPaymentIntent(data);
    });
  }, [setPaymentIntent]);

  return (
    <Layout title="地域・教育魅力化プラットフォーム">
      {paymentIntent && paymentIntent.client_secret ? (
        <Elements
          stripe={getStripe()}
          options={{
            appearance: {
              variables: {
                fontFamily: "YuGothic",
                fontSizeBase: "20px",
                fontWeightNormal: "600",
                colorText: "#505050",
              },
            },
            clientSecret: paymentIntent.client_secret,
          }}
        >
          <Entry paymentIntent={paymentIntent} />
        </Elements>
      ) : (
        <div className="flex justify-center">
          <div className="animate-ping h-5 w-5 bg-blue-600 rounded-full"></div>
          <div className="animate-ping h-5 w-5 bg-blue-600 rounded-full mx-8"></div>
          <div className="animate-ping h-5 w-5 bg-blue-600 rounded-full"></div>
        </div>
      )}
    </Layout>
  );
};

export default EntryPage;
